import {Injectable} from "@angular/core";
import {BehaviorSubject, Observable} from "rxjs";

@Injectable({
    providedIn: "root",
})
export class SelectionService {
    private activeModuleBehaviorSubject = new BehaviorSubject({} as any);
    activeModule: Observable<number> =
        this.activeModuleBehaviorSubject.asObservable();

    private activePageBehaviorSubject = new BehaviorSubject({} as any);
    activePage: Observable<number> =
        this.activePageBehaviorSubject.asObservable();

    private productionLineBehaviorSubject = new BehaviorSubject<string | null>(null);
    currentProductionLine: Observable<string | null> =
        this.productionLineBehaviorSubject.asObservable();

    private workplaceBehaviorSubject = new BehaviorSubject<string | null>(null);
    currentWorkplace: Observable<string | null> =
        this.workplaceBehaviorSubject.asObservable();

    private categoryBehaviorSubject = new BehaviorSubject<string | null>(null);
    currentCategory: Observable<string | null> =
        this.categoryBehaviorSubject.asObservable();

    private malfunctionBehaviorSubject = new BehaviorSubject<string | null>(null);
    currentMalfunction: Observable<string | null> =
        this.malfunctionBehaviorSubject.asObservable();

    private solutionBehaviorSubject = new BehaviorSubject({} as any);
    currentSolution: Observable<string> =
        this.solutionBehaviorSubject.asObservable();

    private descriptionBehaviorSubject = new BehaviorSubject({} as any);
    currentDescription: Observable<string> =
        this.descriptionBehaviorSubject.asObservable();

    private levelBehaviorSubject = new BehaviorSubject({} as any);
    currentLevel: Observable<string> = this.levelBehaviorSubject.asObservable();

    constructor() {
    }

    changeDescription(description: string) {
        this.descriptionBehaviorSubject.next(description);
    }

    changeActiveModule(activeModule: number) {
        this.activeModuleBehaviorSubject.next(activeModule);
    }

    changeActivePage(activePage: number) {
        this.activePageBehaviorSubject.next(activePage);
    }

    changeProductionLine(productionLineId: string | null) {
        this.productionLineBehaviorSubject.next(productionLineId);
    }

    changeWorkplace(workplaceId: string | null) {
        this.workplaceBehaviorSubject.next(workplaceId);
    }

    changeCategory(categoryId: string | null) {
        this.categoryBehaviorSubject.next(categoryId);
    }

    changeMalfunction(malfunctionId: string | null) {
        this.malfunctionBehaviorSubject.next(malfunctionId);
    }

    changeSolution(solutionId: string | null) {
        this.solutionBehaviorSubject.next(solutionId);
    }

    changeLevel(level: string) {
        this.levelBehaviorSubject.next(level);
    }
}
